import { MortgageType } from './enums/mortgageType';
import { ProductType } from './enums/productType';

export enum PricingVariationKeys {
    productType = 'productType',
    duration = 'duration',
    saronProductId = 'saronProductId',
    saronProductName = 'saronProductName',
    saronBase = 'saronBase',
    mortgageType = 'mortgageType',
    interestRate = 'interestRate',
    interestRateFlex = 'interestRateFlex',
    saronLenderInterest = 'saronLenderInterest',
    saronLenderInterestFlex = 'saronLenderInterestFlex',
    interestRateHomeOption = 'interestRateHomeOption',
    interestRateHomeOptionFlex = 'interestRateHomeOptionFlex',
    greenMortgageInterestRate = 'greenMortgageInterestRate',
    greenMortgageInterestRateFlex = 'greenMortgageInterestRateFlex',
    greenMortgageSaronLenderInterest = 'greenMortgageSaronLenderInterest',
    greenMortgageSaronLenderInterestFlex = 'greenMortgageSaronLenderInterestFlex'
}

export interface IPricingVariation {
    productType: ProductType;
    duration: number;
    saronProductId: number;
    saronProductName: string;
    saronBase: number;
    mortgageType: MortgageType;
    isBestRate: boolean;
    isInterestRateFrom: boolean;
    interestRate: number;
    interestRateFlex: number;
    saronLenderInterest: number;
    saronLenderInterestFlex: number;
    interestRateHomeOption: number;
    interestRateHomeOptionFlex: number;
    greenMortgageInterestRate: number;
    greenMortgageInterestRateFlex: number;
    greenMortgageSaronLenderInterest: number;
    greenMortgageSaronLenderInterestFlex: number;
}
